<template>
    <v-container>
      <v-card class="mt-8">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Subscrições a expirar</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :server-items-length="total"
            :loading="loading"
            :hide-default-footer="true"
            locale="pt-pt"
          >
          
              <template v-slot:item.name="{item}">
                  <p><small>{{ item.name }}</small></p>
              </template>

            
            <template v-slot:item.days_left="{item}">
                  <p><small>{{ item.days_left }}</small></p>
            </template>
            
            <template v-slot:item.subscription_end="{item}">
                  <p><small>{{ item.subscription_end }}</small></p>
            </template>
            
            <template v-slot:item.type="{item}">
                  <p><small>{{ item.type }}</small></p>
            </template>

            <template v-slot:item.actions="{item}">
            <IconView
              class="mr-2"
              @click="viewTenant(item)"
            />
          </template>

          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
</template>
<script>
import IconView from '@/components/ui/IconView.vue';

export default{
  components:{
    IconView
  },
  props: ['data'],
  data(){
    return{
        loading: true,
        items:[],
        total: 0,
        headers:[
            {
            text: 'Cliente',
            sortable: false,
            value: 'name',
            },
            {
            text: 'Dias',
            sortable: false,
            value: 'days_left',
            },
            {
            text: 'Termina a',
            sortable: false,
            value: 'subscription_end',
            },
            {
            text: 'Subscrição',
            sortable: false,
            value: 'type',
            },            
            { 
              text: 'Opções', 
              value: 'actions', 
              sortable: false 
            },
        ],
    }
  },
  mounted(){
    this.loading = true
    this.items = this.data.expiring_subscriptions
    this.total = this.data.expiring_subscriptions.length
    this.loading = false
  },
  methods:{
    viewTenant(tenant){
      this.$router.push('tenants/update/' + tenant.id);
    }
  }
}

</script>